import { render, staticRenderFns } from "./DayaDukungBanner.vue?vue&type=template&id=6db3b4e2&scoped=true"
import script from "./DayaDukungBanner.vue?vue&type=script&lang=js"
export * from "./DayaDukungBanner.vue?vue&type=script&lang=js"
import style0 from "./DayaDukungBanner.vue?vue&type=style&index=0&id=6db3b4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db3b4e2",
  null
  
)

export default component.exports